// Dit is een voorbeeld van een user settings interface. Deze kan uitgebreid worden met meer modules en instellingen naarmate de applicatie groeit.
export const USER_SETTINGS_MODULE_KEYS = {
    PERSONNEL_PLANNING: 'personnelPlanning',
    STAFFING: 'staffing',
    QUERY_LOGGING: 'queryLogging',
} as const;

export type UserSettingsModuleKey = (typeof USER_SETTINGS_MODULE_KEYS)[keyof typeof USER_SETTINGS_MODULE_KEYS];

export interface PersonnelPlanningSettings {
    defaultView?: 'day' | 'week' | 'month';
    showInactiveEmployees?: boolean;
    uniqueRoleKeys?: string[];
}

export enum StaffingDisplayMode {
    All = 'all',
    Leave = 'leave',
    Planning = 'planning',
}

export interface StaffingSettings {
    displayMode?: StaffingDisplayMode;
}

export type QueryLoggingActiveDuration = '1h' | '1d' | '1w';
export type QueryLoggingDuration = 'off' | QueryLoggingActiveDuration;

export interface QueryLoggingEntry {
    duration: QueryLoggingActiveDuration | null;
    expires: string | null;
}

export interface QueryLoggingSettings {
    slow: QueryLoggingEntry;
    all: QueryLoggingEntry;
}

export interface UserSettingsModuleMap {
    [USER_SETTINGS_MODULE_KEYS.PERSONNEL_PLANNING]: PersonnelPlanningSettings;
    [USER_SETTINGS_MODULE_KEYS.STAFFING]: StaffingSettings;
    [USER_SETTINGS_MODULE_KEYS.QUERY_LOGGING]: QueryLoggingSettings;
}

export interface UserSettings {
    version: number;
    modules: Partial<UserSettingsModuleMap>;
}

export interface ApiResponse<T> {
    data: T;
    message: string;
    success: boolean;
}
